import React from "react"
import RevenueOverviewSection from "./RevenueOverviewSection"

// Fixed to a 30-day window for now — add a date-range picker here (mirroring
// DashboardHeader's) once you want this page independently filterable from
// the main dashboard's range.
const CommerceRevenuePanel = ({ organization }) => {
  const orgId = organization?.orgId
  return (
    <div>
      <RevenueOverviewSection orgId={orgId} dateRange="30d" showReportLink={false} />
    </div>
  )
}

export default CommerceRevenuePanel